'use client'

import { type FC } from 'react'
import { type CommonProps } from '@/utils/types'
import cn from '@/utils/classNames'
import { useLayoutState } from './LayoutContext'

/**
 * Hamburger button component
 * @param props - Props
 * @returns Hamburger button component
 */
/* eslint-disable max-len */
const HamburgerBtn: FC<HamburgerBtnProps> = ({ className, ...props }) => {
  const classList = cn('cursor-pointer', className)
  const { toggleSidebar } = useLayoutState()

  return (
    <button aria-label="toggle" className={classList} onClick={toggleSidebar} {...props}>
      <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 14L5.5 12.7222L9 15.2778L12.5 12.7222L16 15.2778L19.5 12.7222L23 15.2778L26.5 12.7222L30 14M2 3.77778L5.5 2.5L9 5.05556L12.5 2.5L16 5.05556L19.5 3.13889L23 5.05556L26.5 3.13889L30 3.77778M2 24.2222L5.5 22.9444L9 25.5L12.5 22.9444L16 25.5C16 25.5 17.8573 22.9444 19.5 22.9444"
          stroke="#E3E9F7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="wave-path"
        />
      </svg>
      <style>
        {`
        .wave-path {
          transition: all 0.3s ease;
        }
        button:hover .wave-path {
          animation: wave 1.5s infinite;
        }
        @keyframes wave {
          0% {
            d: path("M2 14L5.5 12.7222L9 15.2778L12.5 12.7222L16 15.2778L19.5 12.7222L23 15.2778L26.5 12.7222L30 14M2 3.77778L5.5 2.5L9 5.05556L12.5 2.5L16 5.05556L19.5 3.13889L23 5.05556L26.5 3.13889L30 3.77778M2 24.2222L5.5 22.9444L9 25.5L12.5 22.9444L16 25.5C16 25.5 17.8573 22.9444 19.5 22.9444");
          }
          50% {
            d: path("M2 14L5.5 13.7222L9 14.2778L12.5 13.7222L16 14.2778L19.5 13.7222L23 14.2778L26.5 13.7222L30 14M2 3.77778L5.5 3.5L9 4.05556L12.5 3.5L16 4.05556L19.5 3.13889L23 4.05556L26.5 3.13889L30 3.77778M2 24.2222L5.5 23.9444L9 24.5L12.5 23.9444L16 24.5C16 24.5 17.8573 23.9444 19.5 23.9444");
          }
          100% {
            d: path("M2 14L5.5 12.7222L9 15.2778L12.5 12.7222L16 15.2778L19.5 12.7222L23 15.2778L26.5 12.7222L30 14M2 3.77778L5.5 2.5L9 5.05556L12.5 2.5L16 5.05556L19.5 3.13889L23 5.05556L26.5 3.13889L30 3.77778M2 24.2222L5.5 22.9444L9 25.5L12.5 22.9444L16 25.5C16 25.5 17.8573 22.9444 19.5 22.9444");
          }
        }
      `}
      </style>
    </button>
  )
}
/* eslint-enable max-len */

export interface HamburgerBtnProps extends CommonProps<HTMLButtonElement> {

}

export default HamburgerBtn
